import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from 'react-redux';
/* import useMediaQuery from '@mui/material/useMediaQuery'; */
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import profileImge from '../../../img/profileImage.png'
import { fetchUserDetail } from '../../../redux';
import InstagramImg from '../../../img/socialHandles/instagram.png'
import YoutubeImg from '../../../img/socialHandles/youtube.png'
import FacebookImg from '../../../img/socialHandles/facebook2.png'
import LinkedinImg from '../../../img/socialHandles/linkedin.png'
import TwitterImg from '../../../img/socialHandles/x.png'
import SpotifyImg from '../../../img/socialHandles/spotify.png'
import website from '../../../img/socialHandles/website.png'
import Imbdlogo from '../../../img/socialHandles/imbd-logo.png'
import { verifyServiceHandler } from '../../../_services/profile/verifyArtist/verifyArtist.service.jsx'
import SnackbarContainer from "../../Snackbar"
import { setLoader, setSnackBar, setSnackBarMessage, setSnackBarVariant } from '../../../redux';
import { formSnackbar } from '../../../_services/_constants/snackbar.constant'
import useMediaQuery from '@mui/material/useMediaQuery';
import { gnTranslations } from '../../../_services/_constants/translation.constants';
import { updateProfile } from '../../../_services/profile/profileUpdate.service';
import VerifiedIcon from '@mui/icons-material/Verified';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Reusable section header
const SectionHeader = ({ children }) => (
    <Box className='d-flex align-items-center'>
        <span className="fs-6 text-secondary">{children}</span>
        <hr className='ms-2' style={{ flexGrow: 1, border: '1px solid rgba(0,0,0,0.12)' }} />
    </Box>
);

// Reusable info row
const InfoRow = ({ label, value }) => (
    <Box className="mb-2">
        <SectionHeader>{label}</SectionHeader>
        <Box className="m-2">{value || <strong>No Information</strong>}</Box>
    </Box>
);

// Reusable info list
const InfoList = ({ label, items, renderItem }) => (
    <Box className="mb-2">
        <SectionHeader>{label}</SectionHeader>
        <Box className="m-2 d-flex flex-wrap">
            {items?.length ? items.map(renderItem) : <strong>No Information</strong>}
        </Box>
    </Box>
);

function ArtistVerification({ name }) {
    const userData = useSelector((state) => state.userData.userData);
    const dispatch = useDispatch()
    const smallViewport = useMediaQuery('(max-width:768px)');
    const [open, setOpen] = useState(false)
    const [remark, setRemark] = useState('')
    const [remarkError, setRemarkError] = useState('')
    const [errorState, setErrorState] = useState(false)
    const [disbleBtn, setDisableBtn] = useState(false)
    const [paraText, setParaText] = useState('')
    const [suggestionText, setSuggestionText] = useState(null)
    const [openSnackBar, setOpenSnackBar] = React.useState(false);

    const handleClick = () => {
        setOpenSnackBar(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
    };
    let textClass;
    useEffect(() => {
        if (userData.id) {
            userData && userData.verification_status ? getParagraphText(userData.verification_status.verificationStatus.toLowerCase()) : getParagraphText()
            //to check the neccessary input are there before applying for verification
            if (userData) {
                if ((userData.avatar_url != null && userData.avatar_url !== undefined) && (userData.social && userData.social.length > 0) && (userData.profile_pictures && userData.profile_pictures.length > 0)) {
                    userData && userData.verification_status && userData.verification_status.verificationStatus.toLowerCase() !== 'unverified' && userData.verification_status.verificationStatus.toLowerCase() !== 'rejected' ? setDisableBtn(true) : setDisableBtn(false)
                    setSuggestionText(null)
                }
                else {
                    setDisableBtn(true)
                    setSuggestionText('To Apply for Verification: Fill in all profile details completely — incomplete profiles will not be considered.')
                }
            }
        }
    }, [userData])
    useEffect(() => {
        dispatch(fetchUserDetail()) // to laod the latest values of artist
    }, [])

    const getCurrentTextClassAsStatus = () => {
        if (userData && userData.verification_status && userData.verification_status.verificationStatus) {
        }
        else
            return 'text-danger'
        //return userData && userData.isVerified?'text-success':'text-danger'

    }
    //get current text to get display
    const getParagraphText = (vrStatus) => {
        if (userData && userData.verification_status && userData.verification_status.verificationStatus) {
            switch (vrStatus.toLowerCase()) {
                case 'unverified':
                    {
                        setParaText(gnTranslations.verification.verfnStart)
                        break;
                    }
                case 'pending':
                    {
                        setParaText(gnTranslations.verification.verfnPending)
                        break;
                    }
                case 'rejected':
                    {
                        setParaText(gnTranslations.verification.verfnRejected)
                        break;
                    }
                case 'verified':
                    {
                        setParaText(gnTranslations.verification.verfnApproved)
                        break;
                    }
                default: {
                    setParaText(gnTranslations.verification.verfnStart)
                    break;
                }
            }
        }
        else {
            setParaText(gnTranslations.verification.verfnStart)
        }
    }

    const getSocialIcon = (socialTypeCode) => {
        switch (socialTypeCode) {
            case 'facebook_1': {
                return <img style={{ widht: '32px', height: '32px' }} src={FacebookImg} alt="Not found" />
            }
            case 'instagram_2': {
                return <img style={{ widht: '32px', height: '32px' }} src={InstagramImg} alt="Not found" />
            }
            case 'twitter_3': {
                return <img style={{ widht: '32px', height: '32px' }} src={TwitterImg} alt="Not found" />
            }
            case 'linkedin_4': {
                return <img style={{ widht: '32px', height: '32px' }} src={LinkedinImg} alt="Not found" />
            }
            case 'youtube_5': {
                return <img style={{ widht: '32px', height: '32px' }} src={YoutubeImg} alt="Not found" />
            }
            case 'spotify_6': {
                return <img style={{ widht: '32px', height: '32px' }} src={SpotifyImg} alt="Not found" />
            }
            case 'website': {
                return <img style={{ widht: '32px', height: '32px' }} src={website} alt="Not found" />
            }
            case 'imdb': {
                return <img style={{ widht: '32px', height: '32px' }} src={Imbdlogo} alt="Not found" />
            }
            default:
                return
        }
    }

    const validationHandler = (e) => {
        if (!remark) {
            setRemarkError('Please enter your remark!');
            setErrorState(true)
            return true;
        }
        else if (remark.length > 3000) {
            setRemarkError('Max character limit is 3000');
            setErrorState(true)
            return true;
        }
        else {
            setRemarkError('');
            setErrorState(false)
            return false
        }
    }
    const verificationRequestHandler = (e) => {
        e.preventDefault();
        e.stopPropagation()
        let isNotValid = validationHandler();
        if (isNotValid) {
            return;
        }
        else {
            dispatch(setSnackBar(true))
            dispatch(setSnackBarMessage(formSnackbar.verifyArtist.verficationApply))
            dispatch(setSnackBarVariant('info'))

            setRemarkError('');
            setErrorState(false)
            let dataObj = {}
            dataObj.artist_id = userData.id.toString();
            /* code for verification_status [unverified = 1, pending=2, rejected=4, verified=3] */
            dataObj.verification_status = '2'
            dataObj.artist_remark = remark

            verifyServiceHandler(dataObj, 'POST')
                .then(response => {
                    if (response.status === 200) {
                        dispatch(setSnackBarMessage(formSnackbar.verifyArtist.verificationApplied))
                        dispatch(setSnackBarVariant('success'))
                        setTimeout(() => { dispatch(setSnackBar(false)) }, 2000) // to auto hide the message
                        updateUserInfo()//will be removed later
                        setOpen(false)
                        setDisableBtn(true)
                        //dispatch(fetchUserDetail()) /*  update the redux store with the latest state transition */
                    }
                    else {
                        //alert(`The service has been responded with the error code ${response.status}`)
                        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg))
                        dispatch(setSnackBarVariant('error'))
                        setTimeout(() => { dispatch(setSnackBar(false)) }, 3000)
                    }
                })
        }
    }

    /* Function created  */
    const updateUserInfo = () => {
        let updateObj = {
            verification_status: '2',
            isverified: false
        }
        updateProfile(updateObj, userData.id)
            .then((response) => {
                dispatch(fetchUserDetail())
            })
    }

    const drawerCloseHandler = () => {
        setRemarkError('');
        setErrorState(false)
        setRemark(null)
        setOpen(false)
    }
    return (
        <>
            {suggestionText && <Alert variant="standard" severity="warning" onClose={() => setSuggestionText(false)}>{suggestionText}</Alert>}
            <Box className="py-4 px-3 mb-5">
                {/*  Heading Row */}
                <Box className="row mb-4">
                    <Box className={`col-12 ${smallViewport ? 'px-1' : 'px-4'}`}>
                        <h2> GNTunes Verification</h2>
                        <p className='paragraph'>{paraText}</p>
                    </Box>
                </Box>
                {/* body Row */}
                <Box>
                    <Box className={`d-flex flex-wrap justify-content-between ${smallViewport ? '' : 'px-3'}`}>
                        <Box className="verifyCol1 p-4 shadow bg-white rounded">
                            <Box>
                                {/* Avatar and Status */}
                                <Box className={`d-flex align-items-center mb-4 flex-wrap ${smallViewport ? 'px-0' : 'px-3'}`}>
                                    <Box id="artist-avatar">
                                        <Box className="item" style={{ width: 100 }}>
                                            <Box>
                                                {userData?.isVerified && <span className="notify-badge"><VerifiedIcon sx={{ color: '#e02221', borderRadius: '50%', backgroundColor: '#fff' }} /></span>}
                                                <img className="rounded-circle" style={{ height: 100, width: 100 }} src={userData?.avatar_url || (userData?.avatar ? process.env.REACT_APP_BASEURL_MEDIA + '/media/' + userData.avatar : profileImge)} alt="Image not found" />
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box id="artist-status">
                                        <h2>{userData?.name}</h2>
                                        <Box className={`${getCurrentTextClassAsStatus()} d-flex align-items-center justify-content-center w-50 p-1`} style={{ border: 'solid 2px', borderRadius: 20, fontSize: '1rem' }}>
                                            <strong>{userData?.verification_status?.verificationStatus || 'Unverified'}</strong>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* Info Sections */}
                                <InfoRow label="About" value={userData?.about} />
                                <InfoList label="Category" items={userData?.category} renderItem={item => <span className="me-3 fw-bold" key={item.id}>{item.category}</span>} />
                                <InfoList label="Genre" items={userData?.genres} renderItem={item => <span className="me-3 fw-bold" key={item.id}>{item.genre}</span>} />
                                <InfoList label="Social Platforms" items={userData?.social} renderItem={item => (
                                    <a href={item.url} key={item.id}><span className="me-2">{getSocialIcon(item.socialType.socialTypeCode)}</span></a>
                                )} />
                            </Box>
                        </Box>
                        <Box style={{ width: 20, height: 20 }}></Box>
                        <Box className="verifyCol2 p-4 shadow bg-white rounded">
                            <Box>
                                <InfoList label="Experience" items={userData?.experience} renderItem={item => <Box className="ms-2 fw-bold" key={item.id}>{item.companyName}</Box>} />
                                <InfoList label="Language" items={userData?.languages} renderItem={item => <span className="ms-2 fw-bold" key={item.id}>{item.language}</span>} />
                                <InfoRow label="Contact Information" value={userData?.contactNumber} />
                                <Box className="mb-2">
                                    <SectionHeader>Website</SectionHeader>
                                    <Box className="m-2">
                                        <Box className="mb-2">
                                            <Box>
                                                <strong>User Bio: </strong>
                                                <a className="me-2" title="Your Profile" target="_blank" href={`${process.env.REACT_APP_CREATORURL}/${userData?.userHandle}`}>
                                                    {`${process.env.REACT_APP_CREATORURL}/${userData?.userHandle}`}
                                                </a>
                                            </Box>
                                            <Box>
                                                <strong>Playlist: </strong>
                                                <a target="_blank" title="Your Playlist" href={`${process.env.REACT_APP_CREATORURL}/${userData?.userHandle}/playlist`}>
                                                    {`${process.env.REACT_APP_CREATORURL}/${userData?.userHandle}/playlist`}
                                                </a>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* --------- multiple image --------- */}
                                <Box className="mb-2">
                                    <SectionHeader>Profile Pictures</SectionHeader>
                                    <Box className="m-2">
                                        <Box className="mb-2 d-flex flex-wrap align-items-center">
                                            {userData?.profile_pictures?.map((data, index) => (
                                                <Box key={index} className="border-1 border-dark-subtle rounded p-2" style={{ height: 100, width: 100 }}>
                                                    {
                                                        data?.type === "Video" ?
                                                            <video
                                                                src={data?.url}
                                                                controls
                                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                            />
                                                            :
                                                            <img src={data?.url || data?.path} alt={data?.picture_order} className='h-100 w-100 rounded' />
                                                    }
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                                <Box className="mt-4" style={{ marginTop: 50 }}>
                                    <button disabled={!!disbleBtn} className="gn-actionbtn" onClick={() => setOpen(true)}>APPLY FOR VERIFICATION</button>
                                </Box>
                            </Box>
                        </Box>


                    </Box>
                </Box>
            </Box>
            {/* Drawer for add platform */}
            <Drawer
                sx={{
                    width: smallViewport ? 300 : 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: smallViewport ? 300 : 400,
                        boxSizing: 'border-box',
                        backgroundColor: '#F2EDED'
                    },
                }}
                anchor="right"
                open={open}
            >
                <Box>
                    <Box className="p-4 shadow d-flex justify-content-between align-items-center" style={{ backgroundColor: '#F6F6F6' }}>
                        <Box><h5>Add your remark</h5></Box>
                        <Box style={{ position: 'relative', top: '-5px' }}>
                            <button title="Close" className="icononly-btn" onClick={drawerCloseHandler}><CloseIcon /></button>
                        </Box>
                    </Box>
                    <Box className="p-4">
                        <p>Please add your remark, why do you need to be verified?</p>
                        <form onSubmit={verificationRequestHandler}>
                            <Box className='mb-4'>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Remark"
                                    multiline
                                    rows={4}
                                    required
                                    value={remark}
                                    onChange={e => setRemark(e.target.value)}
                                    sx={{ width: '100%' }}
                                    error={errorState}
                                    helperText={remarkError}
                                    onBlur={validationHandler}
                                />
                            </Box>
                            <button type="submit" className='gn-actionbtn'>Submit</button>
                            <button type="button" className='ms-4 gn-actionbtn outlined' onClick={drawerCloseHandler}>Cancel</button>
                        </form>
                    </Box>
                </Box>
            </Drawer>
            <SnackbarContainer />
        </>
    );
}

export default ArtistVerification
